var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"10"}},[_vm._t("title")],2),_c('v-col',{attrs:{"cols":"2"}},[_c('language-selector')],1)],1),_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }